import React, {useState, useCallback, useEffect, useMemo} from 'react'
import { shallowEqual, useSelector, useDispatch } from 'react-redux'
import { Tooltip, Table } from 'antd'
import b_ from 'b_'
import useStorageState from '../../Utils/useStorageState'
import TableSettings from '../../Utils/TableSettings'
import PrintDate from '../../Components/Prints/PrintDate'
import PrintDateSubscr from '../../Components/Prints/PrintDateSubscr'
import { Link } from 'react-router-dom'

const b = b_.lock('ArchiveAccountsTable')

function ArchiveAccountsTable({
                      list,
                      tableOnChange,
                      pagination,
                      loading,
                      afterUpdate,
                      onFilter,
                      filters,
                      selected,
                      onSelectChange,
                      handleSave,
                      fieldsChange,
                      dearchiveAccount
                    }) {
  const GetColumns = useCallback(() => {

    return [
      {
        title: 'ID',
        dataIndex: 'id',
        key: 'id',
        width: 75,
        sorter: (a, b) => a.id - b.id,
        render:id => <Link to={`/account/${id}`}>{id}</Link>,
        // render: (value, rec) => <><span>{value}</span><Popover content="Dearchive Account"><FolderOpenOutlined style={{color: 'green', marginLeft: '4px'}} onClick={dearchiveAccount(value)} /></Popover></>
      },
      {
        title: 'Login',
        dataIndex: 'login',
        key: 'login',
        width: 288,
        // sorter: (a, b) => a.state.localeCompare(b.state),
      },
      {
        title: 'Currency',
        dataIndex: 'currency',
        key: 'currency',
        width: 95,
        sorter: (a, b) => a - b,
      },
      {
        title: 'Balance (EUR)',
        dataIndex: 'balance',
        key: 'balance',
        width: 150,
        sorter: (a, b) => a - b,
        render: (balance_eur, record) => (
          <Tooltip placement="topLeft" title={record.balance_usd}>
            {balance_eur}
          </Tooltip>
        ),
      },
      {
        title: 'Subscriptions',
        dataIndex: 'passUltNextCharge',
        key: 'subscriptions',
        align: 'center',
        width: 110,
        render: (_, rec) => {
        const now = Date.now()
        const passUltNextCharge = rec?.details?.passUltNextCharge
        return {
          props: {
            style: { background: now > passUltNextCharge ? "#fcf8e3" : "", color: now > passUltNextCharge ?  "#c09853" : ""}
          },
          children:
              <>
              {rec?.details?.passUltNextCharge &&
              <>
                Ultimate: <PrintDateSubscr subscr date={rec?.details?.passUltNextCharge} />
              </>
              }
              {rec?.details?.eaAccessNextCharge &&
              <>
                <br />
                EA: <PrintDateSubscr subscr date={rec?.details?.eaAccessNextCharge} />
              </>
              }
              </>
        }
        }
      },
      {
        title: 'State changed at',
        dataIndex: 'updateTime',
        key: 'updateTime',
        width: 165,
        sorter: (a, b) => a - b,
        render: (updateTime) => <PrintDate withTime date={updateTime} />
      },
      {
        title: 'Comment',
        dataIndex: 'comment',
        key: 'comment',
        width: 103,
        sorter: (a, b) => a.state.localeCompare(b.state),
      }
    ]; 
  }, [filters, list])

  const [columns, setColumns] = useState(GetColumns());

  const [Checkboxs, setCheckbox] = useState([]);

  const [AllCheckbox, setAllCheckbox] = useStorageState('archive_accs_table', {
    checkedList: Checkboxs,
    indeterminate: false,
    checkAll: true,
});

  const onChangeCheckList = useCallback((checkedList) => {
    setAllCheckbox({
        checkedList,
        indeterminate: !!checkedList.length && checkedList.length < columns.length,
        checkAll: checkedList.length === columns.length,
    });
}, [Checkboxs]);

useEffect(() => {
  let allCheckList = []
  if (list?.length && !Checkboxs.length) {
      GetColumns().forEach((e) => {
          allCheckList.push(e[Object.keys(e)[1]])
          setCheckbox(allCheckList)
      })
  }
}, [list, AllCheckbox, Checkboxs.length, GetColumns])

useEffect(() => {
  if (AllCheckbox.checkAll) {
      setAllCheckbox({
          checkedList: GetColumns().map(e => e.title),
          indeterminate: false,
          checkAll: true,
      })
  }
}, [AllCheckbox.checkAll, GetColumns, setAllCheckbox])

  const onChangeCheckAll = useCallback((e) => {
    setAllCheckbox({
        checkedList: (e.target.checked && columns.map(e => e.title)) || [],
        indeterminate: false,
        checkAll: e.target.checked,
    });
}, [Checkboxs]);

  useEffect(() => {
      setColumns(GetColumns())
  }, [list, loading, filters, GetColumns])

  const columnsFilter = columns.filter(e => AllCheckbox.checkedList.indexOf(e.title) !== -1);
  const loader = loading

  
  return <Table
            rowKey={(record) => `${record.id}_${record.balance_eur}`}
            className={b()}
            bordered
            dataSource={list}
            scroll={{ x: 'max-content' }}
            size="middle"
            onChange={(a, b, c) => tableOnChange(a, b, c)}
            onFilter={onFilter}
            pagination={pagination}
            loading={loader}
            columns={columnsFilter}
            rowClassName={() => b('lock')}
            title={() => <TableSettings
              onChangeCheckAll={onChangeCheckAll}
              allChecks={AllCheckbox}
              Checkboxs={AllCheckbox.checkedList}
              TableColumn={() => GetColumns()}
              setCheckbox={onChangeCheckList}
          />}
            rowSelection={{
              selectedRowKeys: selected,
              onChange: onSelectChange,
            }}
  />
}

export default ArchiveAccountsTable;
